import React from 'react';

export const LoadingLogo = () => (
  <div className="relative flex h-screen flex-col items-center justify-center overflow-hidden bg-surface-base">
    {/* ambient amber glow */}
    <div
      aria-hidden
      className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      style={{
        width: 560,
        height: 560,
        background: 'radial-gradient(circle, rgba(251,191,36,0.12) 0%, transparent 65%)',
        borderRadius: '50%',
      }}
    />
    {/* secondary halo */}
    <div
      aria-hidden
      className="pointer-events-none absolute left-1/2 top-1/2 h-[280px] w-[280px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber/5 animate-pulse"
    />

    <div className="relative z-10 flex flex-col items-center text-center">
      <img
        src="https://www.esay.in/assets/logoanim.gif"
        alt="ESAY"
        className="max-w-[80vw] h-[200px] sm:h-[240px] md:h-[260px]"
        style={{ filter: 'drop-shadow(0 0 30px rgba(251,191,36,0.22))' }}
      />

      {/* indeterminate progress bar */}
      <div className="mt-8 h-[3px] w-[180px] overflow-hidden rounded-full bg-surface-overlay">
        <div
          className="h-full w-1/3 rounded-full bg-amber"
          style={{
            boxShadow: '0 0 12px rgba(251,191,36,0.6)',
            animation: 'esay-progress-track 1.4s cubic-bezier(0.4,0,0.2,1) infinite',
          }}
        />
      </div>

      <div className="mt-4 text-[9.5px] font-bold uppercase tracking-[0.32em] text-amber">
        Engineering Sources Around You
      </div>
    </div>

    <style>{`
      @keyframes esay-progress-track {
        0%   { transform: translateX(-100%); }
        100% { transform: translateX(420%); }
      }
    `}</style>
  </div>
);
